import axios from 'axios'

export const loginWithRedirect = () => {
  window.open(window.env.RESEARCHER_LOGIN_URL, '_self')
}

export const logout = async (jwt) => {
  const signoutUrl = new URL('/api/v1/logout', window.env.SVC_AUTH_BASE_URL)

  // Make the call to the signout endpoint, passing the JWT in the
  // Authorization header because devise needs to know who we are.
  const call = axios.delete(signoutUrl, {
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
    withCredentials: true,
  })

  try {
    await call
    window.open(window.env.SIGNOUT_CALLBACK, '_self')
  } catch (error) {
    console.error('Something went wrong when logging out.')
  }
}
